<app-menu-bar>
  <app-interaction-bar>
    <app-pricing-banner></app-pricing-banner>
    <router-outlet></router-outlet>
  </app-interaction-bar>
</app-menu-bar>
